import { MutableRefObject, useRef } from "react";

import { Mode } from "./index";

interface IProps {
  onMouseDown: () => void;
  draggingMode: MutableRefObject<Mode | null>;
  draggingOriginClickX: MutableRefObject<number | null>;
  onMouseUpRef: MutableRefObject<EventListener | undefined>;
  onMouseMoveRef: MutableRefObject<EventListener | undefined>;
  rowRef: MutableRefObject<HTMLDivElement | null>;
}

const useOnMouseDown = ({
  onMouseDown,
  draggingMode,
  draggingOriginClickX,
  onMouseUpRef,
  onMouseMoveRef,
  rowRef
}: IProps) => {
  const timeout = useRef<NodeJS.Timeout>();

  const getMouseDownHandler = (mode) => (event) => {
    event.preventDefault();
    event.stopPropagation();
    onMouseUpRef.current && document.body.addEventListener("mouseup", onMouseUpRef.current);
    timeout.current = setTimeout(() => {
      draggingMode.current = mode;
      draggingOriginClickX.current = event.clientX - (rowRef.current?.getBoundingClientRect().x || 0);
      onMouseMoveRef.current && document.body.addEventListener("mousemove", onMouseMoveRef.current);
      onMouseDown();
    }, 200);
  };

  const cancelMouseDown = () => timeout.current && clearTimeout(timeout.current);

  return {
    getMouseDownHandler,
    cancelMouseDown
  };
};

export default useOnMouseDown;
